import { render, staticRenderFns } from "./SplitLayoutRight.vue?vue&type=template&id=cbed5180&scoped=true&"
import script from "./SplitLayoutRight.vue?vue&type=script&lang=js&"
export * from "./SplitLayoutRight.vue?vue&type=script&lang=js&"
import style0 from "./SplitLayoutRight.vue?vue&type=style&index=0&id=cbed5180&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbed5180",
  null
  
)

export default component.exports